import { DEFAULT_LOCATION } from '../brands/default/config';

export function getLocationShortName(location) {
  if (location && location.shortName) {
    return location.shortName;
  } else {
    return DEFAULT_LOCATION.shortName;
  }
}
